import { ComponentStyleConfig, Tooltip } from "@chakra-ui/react";

const TooltipTheme: ComponentStyleConfig = {
  baseStyle: {
    "--tooltip-bg": "var(--chakra-colors-gray-50)",
    borderRadius: "8px",
    color: "gray.700",
    px: "12px",
    py: "8px",
    boxShadow: "lg",
    "&&": {
      textStyle: "small",
    },
  },
};

Tooltip.defaultProps = {
  openDelay: 500,
  hasArrow: true,
};

export default TooltipTheme;
